import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  MenuItem,
  FormControl,
  Chip
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";
import Header from "../../components/Header";
import { PostCvPostulante } from "../../services/postulantes.services";
import {getApiBaseUrl} from '../../utils/getApiBaseUrl';
import ModalCharge from "../../modal/modalCharge";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
dayjs.locale("es");

/* ================= VALIDACIÓN ================= */
const checkoutSchema = yup.object().shape({
  Nombres: yup.string().required("El nombre es requerido"),
  Apellidos: yup.string().required("El apellido es requerido"),
  direccion: yup.string().required("La dirección es requerida"),
  cedula: yup.number().required("La dirección es requerida"),
  sexo: yup.string().required("El sexo es requerido"),

telefonos: yup.array().of(
  yup.string()
    .matches(/^[0-9]+$/, "Solo números")
    .min(9, "Muy corto")
    .max(15, "Muy largo")
    .required("Teléfono requerido")
).min(1, "Ingrese al menos un teléfono"),

  puestos: yup.array().of(
    yup.string().required("Puesto requerido")
  ).min(1, "Ingrese al menos un puesto"),

  experiencias: yup.array().of(
    yup.string().required("Experiencia requerida")
  ).min(1, "Ingrese al menos una experiencia"),

  referencias: yup.array().of(
    yup.string().required("Referencia requerida")
  ).min(1, "Ingrese al menos una referencia"),

tel_ref: yup.array().of(
  yup.string()
    .matches(/^[0-9]+$/, "Solo números")
    .required("Teléfono de referencia requerido")
).min(1, "Ingrese al menos un teléfono de referencia"),

fecha_recepcion: yup
  .string()
  .required("Fecha requerida"),

  adjunto: yup.string().required("Debe subir el CV")
});


/* ================= COMPONENTE DINÁMICO ================= */
const DynamicChipsInput = ({
  label,
  values,
  setFieldValue,
  setFieldTouched,
  name,
  error,
  touched
}) => {
  const [input, setInput] = useState("");

  const handleAdd = () => {
    if (!input.trim()) return;
    setFieldValue(name, [...values, input.trim()]);
    setFieldTouched(name, true);
    setInput("");
  };

  // ✅ FIX: permite agregar con Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  // ✅ FIX: si el usuario sale del campo sin presionar +, se agrega igual
  const handleBlur = () => {
    if (input.trim()) {
      handleAdd();
    }
    setFieldTouched(name, true);
  };

  const handleDelete = (index) => {
    const newValues = values.filter((_, i) => i !== index);
    setFieldValue(name, newValues);
    setFieldTouched(name, true);
  };

  return (
    <FormControl fullWidth variant="filled" sx={{ gridColumn: "span 2" }}>
      <Box display="flex" gap="10px">
        <TextField
          variant="filled"
          label={label}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}   // ✅ Enter agrega
          onBlur={handleBlur}         // ✅ blur agrega si hay texto
          fullWidth
          error={!!touched && !!error}
        />
        <Button
  onClick={handleAdd}
  sx={{
    backgroundColor: "rgb(206, 220, 0)",
    color: "black",
    minWidth: "60px",   // ancho fijo
    height: "52px",     // alto fijo
    "&:hover": { backgroundColor: "#bac609" }
  }}
>
  <span style={{ fontSize: "32px", lineHeight: 1 }}>+</span>
</Button>
      </Box>

      <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
        {values.map((item, index) => (
          <Chip key={index} label={item} onDelete={() => handleDelete(index)} />
        ))}
      </Box>

      {touched && error && (
        <Typography color="error">{error}</Typography>
      )}
    </FormControl>
  );
};

/* ================= MAIN ================= */
const CvPostulante = () => {
      const [isLoading, setIsLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");

const handleSubmit = async (values, { resetForm }) => {
  setIsLoading(true);

  try {
    const dataToSend = {
      Nombres: values.Nombres,
      Apellidos: values.Apellidos,
      telefono: values.telefonos.join(";"),
      cedula: values.cedula,
      ref: values.referencias.join(";"),
      xp: values.experiencias.join(";"),
      sexo: values.sexo,
      direccion: values.direccion,
      Puesto: values.puestos.join(";"),
      adjunto: values.adjunto,
      Estado: 0,
      fecha_recepcion: values.fecha_recepcion,
      tel_ref: values.tel_ref.join(";"),
      obs_estado: ""
    };

    console.log("📦 PAYLOAD ENVIADO:", JSON.stringify(dataToSend, null, 2));

    const response = await PostCvPostulante(dataToSend);

    console.log("RESPUESTA:", response);

    // 🔥 Éxito
    setRegistrationSuccess(true);
    resetForm();

  } catch (error) {
    console.error(error);

    // 🔴 Error backend
    setRegistrationError(true);
    setError(error.message);

  } finally {
  setTimeout(() => {
    setIsLoading(false);
  }, 1000); // 1 segundo
}
};

const handleFileUpload = async (file, setFieldValue) => {
  try {
    const formData = new FormData();

    formData.append("image", file); // 🔥 IMPORTANTE (no "file")

    const response = await fetch(`${getApiBaseUrl()}upload`, {
      method: "POST",
      body: formData
    });

    if (response.ok) {
      const data = await response.json();

      console.log("RUTA:", data.filePath);

      setFieldValue("adjunto", data.filePath); // 🔥 GUARDA EN FORMIK
    } else {
      console.error("Error al subir archivo");
    }
  } catch (error) {
    console.error("Error upload:", error);
  }
};
  return (
    <Box m="20px">
      <Header title="Registro de Postulantes" subtitle="Registrar cv de postulantes" />
        <ModalCharge isLoading={isLoading} />
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
        <ModalError open={registrationError} onClose={() => setRegistrationError(false)} error={error} />
      <Formik
        initialValues={{
          Nombres: "",
          Apellidos: "",
          direccion: "",
          cedula: "",
          sexo: "",
          telefonos: [],
          puestos: [],
          experiencias: [],
          referencias: [],
          tel_ref: [],
          fecha_recepcion: null,
          adjunto: ""
        }}
        validationSchema={checkoutSchema}
        onSubmit={handleSubmit}
        validateOnChange={false} 
        validateOnBlur={false} 
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="20px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            >

              <TextField
                variant="filled"
                label="Nombres"
                name="Nombres"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.Nombres}
                error={!!touched.Nombres && !!errors.Nombres}
                helperText={touched.Nombres && errors.Nombres}
                sx={{ gridColumn: "span 2" }}
              />

              <TextField
                variant="filled"
                label="Apellidos"
                name="Apellidos"
                onChange={handleChange}
                value={values.Apellidos}
                error={!!touched.Apellidos && !!errors.Apellidos}
                helperText={touched.Apellidos && errors.Apellidos}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
  variant="filled"
  label="Cédula de Identidad"
  name="cedula"
  onChange={handleChange}
  onBlur={handleBlur}
  value={values.cedula}
  error={!!touched.cedula && !!errors.cedula}
  helperText={touched.cedula && errors.cedula}
  sx={{ gridColumn: "span 1" }}
/>
              <TextField
                select
                variant="filled"
                label="Sexo"
                name="sexo"
                value={values.sexo}
                onChange={handleChange}
                error={!!touched.sexo && !!errors.sexo}
                helperText={touched.sexo && errors.sexo}
                sx={{ gridColumn: "span 1" }}
              >
                <MenuItem value="Masculino">Masculino</MenuItem>
                <MenuItem value="Femenino">Femenino</MenuItem>
              </TextField>

              <TextField
                variant="filled"
                label="Dirección"
                name="direccion"
                onChange={handleChange}
                value={values.direccion}
                error={!!touched.direccion && !!errors.direccion}
                helperText={touched.direccion && errors.direccion}
                sx={{ gridColumn: "span 2" }}
              />

              {/* DINÁMICOS */}
              <DynamicChipsInput
                label="Teléfonos"
                values={values.telefonos}
                setFieldValue={setFieldValue}
                name="telefonos"
                error={errors.telefonos}
                touched={touched.telefonos}
                setFieldTouched={setFieldTouched}
              />

              <DynamicChipsInput
                label="Puestos"
                values={values.puestos}
                setFieldValue={setFieldValue}
                name="puestos"
                error={errors.puestos}
                touched={touched.puestos}
                setFieldTouched={setFieldTouched}
              />

              <DynamicChipsInput
                label="Experiencias"
                values={values.experiencias}
                setFieldValue={setFieldValue}
                name="experiencias"
                error={errors.experiencias}
                touched={touched.experiencias}
                setFieldTouched={setFieldTouched}
              />

              <DynamicChipsInput
                label="Referencias"
                values={values.referencias}
                setFieldValue={setFieldValue}
                name="referencias"
                error={errors.referencias}
                touched={touched.referencias}
                setFieldTouched={setFieldTouched}
              />

              <DynamicChipsInput
                label="Tel. Referencias"
                values={values.tel_ref}
                setFieldValue={setFieldValue}
                name="tel_ref"
                error={errors.tel_ref}
                touched={touched.tel_ref}
                setFieldTouched={setFieldTouched}
              />


  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
  <DatePicker
    label="Fecha Recepción"
    value={values.fecha_recepcion ? dayjs(values.fecha_recepcion) : null}
    onChange={(newValue) => {
      setFieldValue(
        "fecha_recepcion",
        newValue ? newValue.format("YYYY-MM-DD") : ""
      );
    }}
    slotProps={{
      textField: {
        variant: "filled",
        error: !!touched.fecha_recepcion && !!errors.fecha_recepcion,
        helperText: touched.fecha_recepcion && errors.fecha_recepcion,
        sx: { gridColumn: "span 1" }
      }
    }}
  />
</LocalizationProvider>

    <Box sx={{ gridColumn: "span 1" }}>
  <Typography fontSize="14px" mb="5px">
    Subir CV
  </Typography>

  <input
    type="file"
    accept=".pdf,image/*"
    onChange={(e) => {
      const file = e.target.files[0];

      if (!file) return;

      console.log("FILE:", file); // 🔍 debug

      handleFileUpload(file, setFieldValue);
    }}
  />

  {touched.adjunto && errors.adjunto && (
    <Typography color="error" fontSize="12px">
      {errors.adjunto}
    </Typography>
  )}
</Box>



            </Box>

            {/* BOTON */}
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  border: "none",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#bac609" }
                }}
                variant="contained"
              >
                Registrar Postulante
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CvPostulante;